import { render } from "./IconField.vue?vue&type=template&id=d5277b02&scoped=true"
import script from "./IconField.vue?vue&type=script&lang=js"
export * from "./IconField.vue?vue&type=script&lang=js"

import "./IconField.vue?vue&type=style&index=0&id=d5277b02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5277b02"]])

export default __exports__